import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CutIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cut"}/>
}
